import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AdminLayout from "../../layout/adminLayout";
import { environment, apiRoutes } from "../../auth/apiRoute";
import moment from "moment";
import Axios from "axios";
import { CSVLink } from "react-csv";
import {
  Table,
  Tag,
  Space,
  message,
  notification,
  Popconfirm,
  Button,
  Divider,
  Input,
  Spin,
  Form,
  Select,
  Typography,
  Modal,
} from "antd";

import { CloseOutlined, CheckCircleTwoTone } from "@ant-design/icons";

export default function Judges() {
  useEffect(() => {
    setLoading(true);
    getMembers();
    getNominations();
    getQueryAndSetFilter();
    setLoading(false);
  }, []);
  const { Text, Paragraph, Title } = Typography;
  const { Search } = Input;
  const { Option } = Select;
  const [form] = Form.useForm();
  const [member, setMember] = useState({});
  const [loading, setLoading] = useState(false);
  const [hotels, setHotels] = useState([]);
  const [members, setMembers] = useState([]);
  const [filteredMembersData, setFilteredMemberssData] = useState([]);
  const [filteredInfo, setFilter] = useState({});
  const [search, setSearch] = useSearchParams();
  const [selectedMember, setSelectedMember] = useState({});
  const [nominationsData, setNominationsData] = useState([]);
  const defaultJudgeReminderBody = `<p>
Thank you so much for volunteering to participate in the first round judging for the Big Apple Stars Awards! This is just a friendly reminder that your assigned nominations have not been completed. They can be accessed through this link:  <a href="https://bas.hanyc.org/judge" >Judge Portal</a> https://bas.hanyc.org/judge/ 
 </p>

 <p>
Each judge was assigned no more than 7 nominations, which need to be completed no later than Friday, 7/24/26.


 </p>
 <p>
If you are no longer able to participate, please email niki@hanyc.org so that your nominations can be reassigned. Thank you!

 </p>`;
  const [judgeReminderModalOpen, setJudgeReminderModalOpen] = useState(false);
  const [judgeReminderBody, setJudgeReminderBody] = useState(
    defaultJudgeReminderBody,
  );
  const tagColors = ["gold", "lime", "green", "cyan", "blue", "geekblue"];
  const getNominations = async () => {
    try {
      const response = await Axios.post(
        apiRoutes[environment].nominationsJudgeAssignmentList,
      );

      if (response.status == 200) {
        var nominations = response.data;
        nominations = nominations
          .map((item) => {
            return { ...item, ...{ key: item._id } };
          })
          .sort((a, b) => {
            // put no judges on the top
            if (a.judge && !b.judge) {
              return 1;
            }
            if (!a.judge && b.judge) {
              return -1;
            }
          });

        setNominationsData(nominations);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };

  const getMembers = async () => {
    try {
      const response = await Axios.post(apiRoutes[environment].alljudges);

      if (response.status == 200) {
        var nominations = response.data;
        nominations = nominations.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        console.log(nominations);
        setMembers(nominations);
        setFilteredMemberssData(nominations);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };
  const resetAllJudges = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes["admin/resetJudges"]);

      if (response.status == 200) {
        getMembers();
        getNominations();
        openNotification("All Judges have been reset!");
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const bulkAssignNominationsToJudges = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes["admin/assignNominationsToJudges"],
        {
          term: String(new Date().getFullYear()),
          maxPerJudge: 7,
          resetExisting: false,
        },
      );

      if (response.status == 200) {
        await getMembers();
        await getNominations();
        openNotification(
          `Assigned ${response.data.assigned} nominations. Skipped ${response.data.skipped}.`,
        );
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content:
            "Sorry, there was an error. " +
            (error.response.data.message || error.response.data),
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const bulkHashNominationIdentifiers = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes["admin/hashNominationIdentifiers"],
        {
          term: String(new Date().getFullYear()),
        },
      );

      if (response.status == 200) {
        await getNominations();
        openNotification(
          `Scanned ${response.data.scanned} nominations. Updated ${response.data.updated} nominations with ${response.data.replacements} replacements.`,
        );
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content:
            "Sorry, there was an error. " +
            (error.response.data.message || error.response.data),
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const sendJudgeNotifications = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes["admin/judgeNotification"]);

      if (response.status == 200) {
        openNotification(
          `Judge portal notifications queued for ${response.data.sent} judges.`,
        );
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content:
            "Sorry, there was an error. " +
            (error.response.data.message || error.response.data),
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const sendJudgeReminders = async () => {
    if (!judgeReminderBody.trim()) {
      message.error({
        content: "Reminder email body is required.",
        className: "messageBox",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes["admin/judgeReminder"], {
        reminderBody: judgeReminderBody,
      });

      if (response.status == 200) {
        setJudgeReminderModalOpen(false);
        openNotification(
          `Reminder emails queued for ${response.data.sent} judges with incomplete nominations.`,
        );
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content:
            "Sorry, there was an error. " +
            (error.response.data.message || error.response.data),
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description: message,
      placement: "top",
    });
  };
  const onChange = (e) => {
    const value = e.target.value.toLowerCase();
    console.log(value);
    if (!value) {
      setFilteredMemberssData(members);
    } else if (value.length > 4) {
      var filters = members.filter((item) => {
        let keys = Object.keys(item);
        var bool = false;

        keys.forEach((key) => {
          if (key != "_id" && key != "key") {
            if (typeof item[key] === "string" && item[key]) {
              if (item[key].toLowerCase().includes(value)) {
                bool = true;

                return;
              }
            }
          }
        });
        return bool;
      });
      console.log(filters);
      setFilteredMemberssData([...filters]);
    }
  };
  const getQueryAndSetFilter = () => {
    const params = new URLSearchParams(search);

    var obj = {};
    for (const [key, val] of params.entries()) {
      if (key == "hotel" || key == "category" || key == "firstName") {
        if (obj[key]) {
          obj[key].push(val);
        } else {
          obj[key] = [val.split(",")];
        }
      } else if (key == "current") {
        obj[key] = parseInt(val);
      } else {
        obj[key] = val;
      }
    }
    console.log({ obj });
    if (obj) {
      setFilter(obj);
      // setSortedInfo(obj);
    }
  };
  const onSearch = (value) => {
    if (!value) {
      setFilteredMemberssData(members);
    } else if (value.length > 2) {
      var filters = members.filter((item) => {
        let keys = Object.keys(item);
        var bool = false;

        keys.forEach((key) => {
          if (key != "_id" && key != "key") {
            if (typeof item[key] === "string" && item[key]) {
              if (item[key].toLowerCase().includes(value)) {
                bool = true;

                return;
              }
            }
          }
        });
        return bool;
      });
      console.log(filters);
      setFilteredMemberssData([...filters]);
    }
  };
  const clearFilters = () => {
    setFilter({ filteredInfo: null });
    setSearch("");
  };
  const handleChange = (pagination, filters, sorter) => {
    const params = new URLSearchParams();
    console.log(filters);
    var newFilters = {};
    if (filters) {
      for (const [key, val] of Object.entries(filters)) {
        if (val) {
          newFilters[key] = val;
        }
      }
      if (Object.keys(newFilters).length > 0) {
        setSearch(newFilters);
        setFilter(newFilters);
      }
    }

    if (pagination) {
      for (const [key, val] of Object.entries(pagination)) {
        if (val) {
          newFilters[key] = val;
        }
      }
      setSearch(newFilters);
      setFilter(newFilters);
    }
  };
  const handleRoleChange = (value) => {
    console.log(value);
  };

  const assignAllNominationsToJudge = async (record) => {
    setLoading(true);
    // Combine nominations that are either unassigned or assigned to the current judge
    const nominationsIds = nominationsData
      .filter(
        (item) => !item.judge || (item.judge && item.judge._id === record._id),
      )
      .map((item) => item._id);
    console.log(nominationsIds);
    form.setFieldsValue({
      nominations: nominationsIds,
    });

    setLoading(false);
  };
  const confirmNominationsToJudge = async (values) => {
    var newMemberData = selectedMember;
    newMemberData.nominations = values.nominations;
    console.log(newMemberData);
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].addNominationsToJudge,
        newMemberData,
      );
      getNominations();
      openNotification("Nominations have been assigned!");
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const getUnfinishedNumbers = (nominations) => {
    var totalCompleted = 0;
    if (!nominations || nominations.length == 0) {
      return 0;
    }
    for (const item of nominations) {
      // if q1, q2, q3, q4 score is null, then it's not completed
      if (
        item.q1 &&
        item.q1.score != null &&
        item.q2 &&
        item.q2.score != null &&
        item.q3 &&
        item.q3.score != null &&
        item.q4 &&
        item.q4.score != null
      ) {
        totalCompleted += 1;
      }
    }

    return totalCompleted;
  };
  const analyticsTotals = members.reduce(
    (totals, judge) => {
      const assigned = (judge.nominations && judge.nominations.length) || 0;
      const completed = getUnfinishedNumbers(judge.nominations);
      const unfinished = assigned - completed;

      return {
        completedNominations: totals.completedNominations + completed,
        unfinishedNominations: totals.unfinishedNominations + unfinished,
        completedJudges:
          assigned > 0 && unfinished == 0
            ? totals.completedJudges + 1
            : totals.completedJudges,
        uncompletedJudges:
          unfinished > 0
            ? totals.uncompletedJudges + 1
            : totals.uncompletedJudges,
      };
    },
    {
      completedNominations: 0,
      unfinishedNominations: 0,
      completedJudges: 0,
      uncompletedJudges: 0,
    },
  );
  const analyticsData = [
    {
      key: "nominations",
      type: "Nominations",
      completed: analyticsTotals.completedNominations,
      unfinished: analyticsTotals.unfinishedNominations,
    },
    {
      key: "judges",
      type: "Judges",
      completed: analyticsTotals.completedJudges,
      unfinished: analyticsTotals.uncompletedJudges,
    },
  ];
  const analyticsColumns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Completed",
      dataIndex: "completed",
      key: "completed",
      render: (completed) => <Tag color="green">{completed}</Tag>,
    },
    {
      title: "Unfinished",
      dataIndex: "unfinished",
      key: "unfinished",
      render: (unfinished) => (
        <Tag color={unfinished > 0 ? "red" : "default"}>{unfinished}</Tag>
      ),
    },
  ];
  const randomSelect = async () => {
    var nominationsIds = nominationsData
      .filter((item) => item.judge == null)
      .filter((item) => {
        return (
          selectedMember.hotel == null ||
          item.hotel._id != selectedMember.hotel._id
        );
      })
      .filter((item) => {
        return (
          selectedMember.hotels.length == 0 ||
          (selectedMember.hotels
            .map((hotelItem) => hotelItem._id)
            .indexOf(item.hotel._id) < 0 &&
            (!item.judge || item.judge == selectedMember._id))
        );
      })
      .map((item) => item._id);
    var length = 7;
    if (nominationsIds.length < 10) {
      length = nominationsIds.length;
    }
    let randomNominationsIds = [];

    for (var i = 0; i < length; i++) {
      const random = Math.floor(Math.random() * nominationsIds.length);
      randomNominationsIds.push(nominationsIds[random]);
      nominationsIds = nominationsIds.filter(
        (item) => item != nominationsIds[random],
      );
    }
    form.setFieldsValue({ nominations: randomNominationsIds });
  };
  const roleAction = () => {
    return (
      <Space direction="vertical" style={{ width: "100%" }}>
        <Text>{selectedMember.firstName + " " + selectedMember.lastName} </Text>
        <Form
          style={{ width: "90%" }}
          onFinish={(values) => {
            console.log(values);
            confirmNominationsToJudge(values);
          }}
          form={form}
          layout={"vertical"}
          initialValues={{
            nominations: nominationsData.filter(
              (item) => item.judge && item.judge._id == selectedMember._id,
            ),
          }}
        >
          <Form.Item name={"nominations"}>
            <Select
              style={{ width: "100%", lineHeight: "32px" }}
              mode="multiple"
              allowClear
              showSearch
              placeholder="Please select"
              onChange={handleRoleChange}
              optionFilterProp="children"
              filterSort={(optionA, optionB) => {
                // if option is already selected, show on the top
                if (optionA.judge && optionB.judge) {
                  if (optionA.judge == selectedMember._id) {
                    return -1;
                  } else if (optionB.judge == selectedMember._id) {
                    return 1;
                  }
                } else {
                  if (optionA.judge && !optionB.judge) {
                    return 1;
                  } else if (!optionA.judge && optionB.judge) {
                    return -1;
                  }
                }
              }}
            >
              {nominationsData

                .filter((item) => {
                  return (
                    selectedMember.hotels.length == 0 ||
                    (selectedMember.hotels
                      .map((hotelItem) => hotelItem && hotelItem._id)
                      .indexOf(item.hotel._id) < 0 &&
                      (!item.judge || item.judge._id == selectedMember._id))
                  );
                })
                .sort((a, b) => {
                  // put current judge on the top
                  if (a.judge && b.judge) {
                    if (a.judge._id == selectedMember._id) {
                      return -1;
                    } else if (b.judge._id == selectedMember._id) {
                      return 1;
                    }
                  }
                })

                .map((item, index) => (
                  <Option key={item._id}>
                    <div>
                      <div>
                        {item.judge && (
                          <CheckCircleTwoTone twoToneColor="#52c41a" />
                        )}
                        {item.firstName + " " + item.lastName}
                      </div>

                      <small>{item.hotel ? item.hotel.name : "no hotel"}</small>
                    </div>
                  </Option>
                ))}
            </Select>
          </Form.Item>

          <Button
            onClick={() => {
              randomSelect();
            }}
          >
            Random Select 10 Nominations
          </Button>

          <Button htmlType="submit">Confirm</Button>
        </Form>

        <CloseOutlined
          onClick={() => {
            setSelectedMember({});
          }}
        />
      </Space>
    );
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "firstName",
      key: "firstName",

      render: (text, record) => {
        return (
          <Space direction="vertical">
            {record.firstName + " " + record.lastName}

            <small>{record.title}</small>
          </Space>
        );
      },
    },

    {
      title: "Hotel",
      dataIndex: "hotel",
      key: "hotel",
      // filteredValue: filteredInfo.hotel || null,
      // sorter: (a, b) => a.hotel.name.localeCompare(b.hotel.name),
      filters: hotels.map((hotel) => {
        return {
          text: hotel.name,
          value: hotel._id,
        };
      }),
      filterSearch: true,
      onFilter: (value, record) => {
        var bool = false;
        const hotelIds = record.hotels.map((hotel) => hotel._id);
        return record.hotels.map((hotel) => hotel._id).includes(value);
      },
      render: (value, record) => {
        if (record.hotel && record.hotel.name) {
          return <Tag color={tagColors[1]}>{record.hotel.name};</Tag>;
        }
        if (record.hotels.length > 0) {
          return record.hotels.map((hotel, index) => {
            return (
              <Tag color={tagColors[index]} key={hotel.name + record._id}>
                {hotel.name}
              </Tag>
            );
          });
        }
      },
    },

    {
      title: "Nominations Hotel",
      dataIndex: "nominationsHotel",
      key: "nominationsHotel",
      render: (value, record) => {
        if (record.nominations && record.nominations.length > 0) {
          return (
            <Space direction="vertical">
              {record.nominations.map((item, index) => {
                return (
                  <Tag key={item._id}>{item.hotel && item.hotel.name}</Tag>
                );
              })}
            </Space>
          );
        }
        return <Tag color="red">No Nominations</Tag>;
      },
    },

    {
      title: "# Nominations",
      key: "nominations",
      dataIndex: "nominations",
      // filteredValue: filteredInfo.category || null,
      sorter: (a, b) => {
        return (
          (a.nominations && a.nominations.length) -
          (b.nominations && b.nominations.length)
        );
      },
      // onFilter: (value, record) => record.roles.includes(value),
      // filters: roles.map((item) => {
      //   return { text: item, value: item };
      // }),
      render: (text, record) => {
        return (
          <Tag size="large">
            {(record.nominations && record.nominations.length) || 0}
          </Tag>
        );
      },
    },
    {
      title: "Completed Nominations",
      key: "completedNominations",
      dataIndex: "completedNominations",
      sorter: (a, b) =>
        getUnfinishedNumbers(a.nominations) -
        getUnfinishedNumbers(b.nominations),
      render: (text, record) => {
        const numbers = getUnfinishedNumbers(record.nominations);
        return <Tag size="large">{numbers}</Tag>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <Space size="middle">
            <Button
              onClick={() => {
                console.log(record);
                if (selectedMember._id == record._id) {
                  setSelectedMember({});
                  form.setFieldsValue({ nominations: [] });
                } else {
                  setSelectedMember(record);
                  var nominationsIds = nominationsData
                    .filter((item) => {
                      return item.judge && item.judge._id == record._id;
                    })
                    .map((item) => item._id);

                  form.setFieldsValue({ nominations: nominationsIds });
                }
              }}
            >
              Assign Nominations
            </Button>
            <Button
              onClick={() => {
                if (selectedMember._id == record._id) {
                  setSelectedMember({});
                  form.setFieldsValue({ nominations: [] });
                } else {
                  setSelectedMember(record);

                  assignAllNominationsToJudge(record);
                }
              }}
            >
              Assign All Nominations
            </Button>

            <Popconfirm
              title="Are you sure to delete this nomination?"
              onConfirm={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <a>Delete</a>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const getJudgesToDownload = () => {
    const judgesList = members.map((item) => {
      return {
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email,
        title: item.title,
        hotel: item.hotel ? item.hotel.name : "no hotel",
        nominations: item.nominations ? item.nominations.length : 0,
        completedNominations: getUnfinishedNumbers(item.nominations),
      };
    });
    return judgesList;
  };

  return (
    <Spin spinning={loading}>
      <div className="judges-page">
        <div className="judges-page-summary">
          <Paragraph>Total Judges : {members.length}</Paragraph>{" "}
          <Paragraph>
            Unassigned Nominations:{" "}
            {nominationsData.filter((item) => item.judge == null).length}
          </Paragraph>
        </div>
        <Title level={4} className="judges-section-title">
          Judge Completion Analytics
        </Title>
        <Table
          className="judges-analytics-table"
          columns={analyticsColumns}
          dataSource={analyticsData}
          pagination={false}
          size="small"
          scroll={{ x: "max-content" }}
        />
        <Divider />
        <Space className="judges-actions" wrap>
          <Button className="judges-action-button">
            <CSVLink
              filename={`judges_${moment().format("YYYY_MM_DD")}.csv`}
              target="_blank"
              data={getJudgesToDownload()}
            >
              Download Judges CSV
            </CSVLink>
          </Button>
          <Popconfirm
            title="Hash nominee full names and hotel names in current-year nomination answers?"
            onConfirm={bulkHashNominationIdentifiers}
            okText="Hash"
            cancelText="Cancel"
          >
            <Button className="judges-action-button">
              Bulk Hash Names/Hotels
            </Button>
          </Popconfirm>
          <Popconfirm
            title="Assign unassigned nominations across all judges?"
            onConfirm={bulkAssignNominationsToJudges}
            okText="Assign"
            cancelText="Cancel"
          >
            <Button className="judges-action-button" type="primary">
              Bulk Assign Nominations
            </Button>
          </Popconfirm>
          <Popconfirm
            title="Email all judges that their assignments are ready?"
            onConfirm={sendJudgeNotifications}
            okText="Send"
            cancelText="Cancel"
          >
            <Button className="judges-action-button">Notify Judges</Button>
          </Popconfirm>
          <Button
            className="judges-action-button"
            onClick={() => setJudgeReminderModalOpen(true)}
          >
            Send Reminders
          </Button>
          <Popconfirm
            title="Reset all first-round judge assignments and judge roles?"
            onConfirm={resetAllJudges}
            okText="Reset"
            cancelText="Cancel"
          >
            <Button className="judges-action-button" danger>
              Reset All Judges
            </Button>
          </Popconfirm>
        </Space>
        <Modal
          className="judge-reminder-modal"
          title="Send reminder email"
          open={judgeReminderModalOpen}
          onOk={sendJudgeReminders}
          onCancel={() => setJudgeReminderModalOpen(false)}
          okText="Send"
          cancelText="Cancel"
          width={800}
          confirmLoading={loading}
        >
          <Paragraph>
            This message will be sent to judges with incomplete nominations.
          </Paragraph>
          <Input.TextArea
            rows={14}
            value={judgeReminderBody}
            onChange={(event) => setJudgeReminderBody(event.target.value)}
          />
        </Modal>
        <Divider />
        <Space className="judges-search-row" wrap>
          <Search
            className="judges-search"
            placeholder="Search ..."
            onSearch={onSearch}
            enterButton
            onChange={onChange}
          />
          <Button className="judges-clear-button" onClick={clearFilters}>
            Clear filters
          </Button>
        </Space>
        {selectedMember._id ? (
          <>
            <Divider /> {roleAction()}
          </>
        ) : (
          <></>
        )}
        <Divider />
        <Table
          className="judges-main-table"
          columns={columns}
          dataSource={filteredMembersData}
          scroll={{ x: "max-content" }}
          // onChange={handleChange}
          // pagination={{
          //   pageSize: filteredInfo.pageSize || 10,
          //   current: filteredInfo.current || 1,
          // }}
        />
      </div>
    </Spin>
  );
}
